import { render } from "./CoeffPopupSummary.vue?vue&type=template&id=1565f7ea&scoped=true"
import script from "./CoeffPopupSummary.vue?vue&type=script&lang=js"
export * from "./CoeffPopupSummary.vue?vue&type=script&lang=js"

import "./CoeffPopupSummary.vue?vue&type=style&index=0&id=1565f7ea&scoped=true&lang=scss"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1565f7ea"]])

export default __exports__